import { is } from "immutable";
import _ from "lodash";
import React from "react";
import { connect } from "react-redux";
import { RouteComponentProps, withRouter } from "react-router-dom";
import * as redux from "redux";
import * as A from "../../actions";
import * as Comp from "../../components";
import { NavigationTypes } from "../../domain";
import { ContentBlockTypes } from "../../domain/ContentBlockTypes";
import * as M from "../../models";
import { Api } from "../../services/Api";
import { AppState } from "../../store";
import { NotFound } from "./NotFound";

const mapStateToProps = (state: AppState, ownProps: OwnProps | undefined): ConnectedState => {
    let page: M.Page.Page | undefined;
    let status: M.Page.PageStateStatus | undefined;
    const navItem = state.nav.branches.find((n) => n !== undefined
        && state.router.location !== null
        && n.url === state.router.location.pathname);

    if (navItem && navItem.typeId === NavigationTypes.Page.id) {
        status = state.page.statuses.find((x) => x !== undefined && x.id === navItem.recordId);
        page = state.page.pages.find((x) => x !== undefined && x.id === navItem.recordId);
    }

    return {
        api: new Api(state),
        navItem,
        page,
        status,
    };
};

const mapDispatchToProps = (dispatch: redux.Dispatch<AppState>): ConnectedDispatch => ({
    loadPage: (pageId: number) => dispatch(A.Pages.loadPage(pageId)),
    updatePageStatus: (status: M.Page.PageStateStatus) => dispatch(A.Pages.onPageStatusUpdate(status)),
});

type OwnProps = RouteComponentProps<{}> & {
};

interface ConnectedState {
    api: Api;
    navItem?: M.Nav.TreeBranch;
    page?: M.Page.Page;
    status?: M.Page.PageStateStatus;
}

interface ConnectedDispatch {
    loadPage: (pageId: number) => void;
    updatePageStatus: (status: M.Page.PageStateStatus) => void;
}

interface OwnState {
    notFound: boolean;
    page?: M.Page.Page;
}

type CombinedProps = ConnectedState & ConnectedDispatch & OwnProps;

class DefaultPageComponent extends Comp.Base.BaseComponent<CombinedProps, OwnState> {

    public constructor(props: any) {
        super(props);
        this.state = {
            loading: true,
            notFound: false,
        };
    }

    public async componentDidMount() {
        this._isMounted = true;
    }

    public componentWillReceiveProps(nextProps: Readonly<CombinedProps>) {
        if (!is(this.props.navItem, nextProps.navItem) && this._isMounted) {
            const tn = this.props.navItem;
            const nn = nextProps.navItem;
            // console.log("nav item is different", tn, nn);
            if ((!tn && nn)
                || (tn && nn && (tn.recordId !== nn.recordId || tn.typeId !== NavigationTypes.Page.id))) {
                this.setState({ ...this.state, notFound: false });
                this.props.loadPage(nn.recordId);
            }
            else if (nn && nn.typeId !== NavigationTypes.Page.id)
                this.setState({ ...this.state, notFound: true });
        }
    }

    public async componentWillMount() {
        const navItem = this.props.navItem;

        if (navItem && navItem.typeId === NavigationTypes.Page.id) {
            if (!this.props.page)
                await this.props.updatePageStatus({ id: navItem.recordId, loading: true, found: true, errors: [] });
            else
                await this.props.updatePageStatus({ id: navItem.recordId, loading: false, found: true, errors: [] });

            this.props.loadPage(navItem.recordId);
        }
        else {
            this.setState({ ...this.state, notFound: true });
        }

        // this.toggleLoading(false);
    }

    public componentWillUnmount() {
        this._isMounted = false;
    }

    public render() {
        const page = this.props.page;
        const bodyClass = page && page.bodyClass ? page.bodyClass : "";
        const title = page ? page.title : "";
        const loading = this.props.status ? this.props.status.loading : false;
        // const errors =  this.props.status ? this.props.status.errors : [];
        const notFound = this.props.status ? !this.props.status.found : false;

        if (notFound || this.state.notFound)
            return <NotFound />;

        let body = null;
        let sidebar = null;

        if (page && page.contentBlocks) {
            const textBlocks = page.contentBlocks.filter((cb) => cb.typeId === ContentBlockTypes.Text.id);
            if (textBlocks.length) {
                const bodyCB = _.find(textBlocks, (cb) => cb.label === "Body");
                const sidebarCB = _.find(textBlocks, (cb) => cb.label === "Sidebar");

                if (bodyCB)
                    body = <div dangerouslySetInnerHTML={{ __html: (bodyCB as M.Page.ContentText).body || "" }} />;
                if (sidebarCB)
                    sidebar = <div dangerouslySetInnerHTML={{ __html: (sidebarCB as M.Page.ContentText).body || "" }} />;
            }
        }

        return <Comp.Page.PublicPage additionalClasses={bodyClass} pageTitle={title} style={{ position: "relative", minHeight: "200px" }}>
            <Comp.Generic.LoadingSpinner show={loading} />

            <div id="content-primary">
                <h1>{title}</h1>
                {body}
            </div>

            <div id="content-secondary">
                {sidebar}
            </div>
        </Comp.Page.PublicPage>;
    }
}

export const DefaultPage: React.ComponentClass<OwnProps> = connect(mapStateToProps, mapDispatchToProps)(withRouter(DefaultPageComponent) as any);



// WEBPACK FOOTER //
// ./src/containers/page/DefaultPage.tsx